// Copyright 2019 Sorama B.V.

import { WorkflowProperty } from "../WorkflowProperties/WorkflowPropertyObserverManager";
import { WorkflowUriModule, WorkflowUriProperty } from "../WorkflowProperties/WorkflowPropertyUriConverter";

export abstract class IUrlStateService {
    /**
     * Update the Navigation state
     * @param workflowName
     * @param uriModules
     */
    public abstract updateNavigationState(
        workflowName: string,
        uriModules: WorkflowUriModule[],
        replace?: boolean
    ): void;

    /**
     * gets the navigation state
     */
    public abstract getNavigationState(): WorkflowUriModule[];

    /**
     * Updates all properties, corresponding to the prefix. If prefix is undefined, updates all properties.
     * @param workflowProperties
     * @param prefix
     */
    public abstract updatePropertyState(workflowProperties: WorkflowProperty[]): void;

    /***
     * Delete all properties, corresponding to the prefix. All if prefix is undefined
     */
    public abstract deletePropertyStates(prefix: string): void;

    /**
     * Get all properties, corresponding to prefix. Returns all if prefix is undefined.
     * @param prefix
     */
    public abstract getPropertyState(prefix: string): WorkflowUriProperty[];
}
